<template>
  <div class="documents one-component-detail-admin">
    <div class="title-component-admin">
      <el-row type="flex" align="middle" justify="space-between">
        <span>Tài liệu</span>
        <el-upload
          accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv"
          list-type="file"
          action
          :limit="1"
          :show-file-list="false"
          :http-request="uploadDocuments"
        >
          <el-button
            type="primary"
            size="small"
            title="Chọn tài liệu từ máy tính của bạn"
            :loading="loading"
          >
            Thêm
          </el-button>
        </el-upload>
      </el-row>
    </div>
    <div v-if="!documents.length" v-loading="loading" class="empty p-3">
      Chưa có dữ liệu!
    </div>
    <div v-else v-loading="loading" class="list-documents p-3">
      <el-card
        v-for="(doc, index) in documents"
        :key="doc.id"
        class="card-document"
        :class="{'mb-2': index < documents.length - 1}"
      >
        <el-row type="flex" align="middle" justify="space-between">
          <div class="doc-info">
            <i class="el-icon-document text-primary mr-2" />
            <a
              :href="doc.url"
              target="_blank"
              class="doc-title"
              :title="getDocName(doc)"
            >
              {{ getDocName(doc) }}
            </a>
          </div>
          <el-row type="flex" align="middle" class="doc-actions">
            <el-tooltip content="Mở tài liệu" placement="top">
              <i
                class="el-icon-view text-info mr-2 cursor-pointer"
                @click="openDocument(doc.url)"
              ></i>
            </el-tooltip>
            <el-tooltip content="Copy link" placement="top">
              <i
                class="el-icon-copy-document mr-2 cursor-pointer"
                @click="copyLink(doc.url)"
              ></i>
            </el-tooltip>
            <el-tooltip content="Chỉnh sửa" placement="top">
              <i
                class="el-icon-edit text-primary mr-2 cursor-pointer"
                @click="openUploadDocumentPopup(doc)"
              ></i>
            </el-tooltip>
            <el-tooltip content="Xóa" placement="top">
              <i
                class="el-icon-delete text-danger cursor-pointer"
                @click="deleteDocuments(doc)"
              ></i>
            </el-tooltip>
          </el-row>
        </el-row>
      </el-card>
    </div>
    <update-document-popup
      v-if="updateVisible"
      :visible="updateVisible"
      :document="selectedDocument"
      :type="object_type"
      :object="data"
      @reload="loadDocuments"
      @close="() => updateVisible = false"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UpdateDocumentPopup from '../popups/UpdateDocument.vue'

import {
  listStorages,
  deleteStorages,
  createStorage
} from '@/services/storage'
import { getTranslation } from '@/utils/filters'

export default {
  name: 'Documents',
  components: {
    UpdateDocumentPopup
  },
  props: {
    data: Object,
    type: String
  },
  data() {
    return {
      loading: false,
      callingAPI: false,
      documents: [],
      selectedDocument: null,
      updateVisible: false
    }
  },
  computed: {
    ...mapGetters(['language']),
    object_type() {
      if (['artifact', 'room-type'].includes(this.type)) {
        return this.type
      }
      return 'place'
    }
  },
  watch: {
    language: 'loadDocuments',
    'data.id': 'loadDocuments'
  },
  beforeMount() {
    this.loadDocuments()
  },
  methods: {
    getFileName(url) {
      if (!url) return ''
      try {
        const name = url.split('/').pop().split('?')[0]
        return decodeURIComponent(name)
      } catch (e) {
        return url.split('/').pop().split('?')[0]
      }
    },

    getDocName(doc) {
      if (!doc) return ''
      const translation = getTranslation(doc, this.language)
      return (
        (translation && (translation.name || translation.title)) ||
        doc.name ||
        doc.title ||
        doc.file_name ||
        this.getFileName(doc.url) ||
        'Tài liệu'
      )
    },

    loadDocuments() {
      if (!this.data || !this.data.id) return
      this.loading = true
      const params = {
        object_id: this.data.id,
        object_type: this.object_type,
        file_type: 'document',
        order: 'ordered',
        locale: this.language
      }
      listStorages(params)
        .then((res) => {
          this.documents = (res.result || []).map((doc) => ({
            ...doc,
            name: this.getDocName(doc)
          }))
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    uploadDocuments(fileInfo) {
      const params = {
        file: fileInfo.file,
        objectId: this.data.id,
        objectType: this.object_type,
        fileType: 'document',
        locale: this.language
      }
      this.loading = true
      createStorage(params)
        .then(() => {
          this.loadDocuments()
          this.loading = false
        })
        .catch(() => {
          this.loading = false
          this.$notify.error({
            title: 'Thông báo',
            message: 'Không thể upload tài liệu: ' + fileInfo.file.name
          })
        })
    },

    deleteDocuments(doc) {
      this.$confirm('Bạn có chắc chắn muốn xóa không?', 'Xác nhận', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Đóng',
        type: 'warning'
      }).then(() => {
        const ids = [doc.id]
        this.loading = true
        deleteStorages({
          file_type: 'document',
          object_type: this.object_type,
          ids: ids.join(',')
        })
          .then(() => {
            this.documents = this.documents.filter(d => d.id !== doc.id)
            this.loading = false
          })
          .catch(() => {
            this.loading = false
            this.$notify.error({
              title: 'Thông báo',
              message: 'Không thể xóa tài liệu!'
            })
          })
      })
    },

    openUploadDocumentPopup(doc) {
      this.selectedDocument = doc
      this.updateVisible = true
    },

    openDocument(url) {
      if (url) {
        window.open(url, '_blank')
      }
    },

    copyLink(url) {
      if (url) {
        this.$clipboard(url)
        this.$notify.success({
          title: 'Thông báo !',
          message: 'Đã copy thành công !'
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.documents {
  .card-document {
    .doc-info {
      display: flex;
      align-items: center;
      flex: 1;
      min-width: 0;
      margin-right: 12px;
      i {
        font-size: 22px;
        flex-shrink: 0;
      }
      .doc-title {
        color: #303133;
        font-size: 14px;
        text-decoration: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: block;
        flex: 1;
        min-width: 0;
        &:hover {
          color: #409EFF;
        }
      }
    }
    .doc-actions {
      flex-shrink: 0;
    }
    .cursor-pointer {
      cursor: pointer;
      font-size: 16px;
    }
  }
}
</style>
<style lang="scss">
.list-documents {
  .card-document {
    .el-card__body {
      padding: 12px;
    }
  }
}
</style>
